import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import TileProgressBarComponent from './components/TileProgressBarComponent';
import useGetProgressBarData from './hooks/useGetProgressBarData';

const LoadingProgressBar = () => (
  <>
    <span className="WHERE_RAFFLE_GOES!!!" style={{ display: 'none' }} />
    <div id="total_section">
      <div className="progress_header" id="total_header" />
      <div id="total_points" />
    </div>
    <div id="tile_section">
      <div className="progress_header" id="tile_header" />
      <div id="tile_progress_bar" />
    </div>
  </>
);

const ProgressBarComponent = ({ canSuggestTile, campaignUuid }) => {
  const {
    demo,
    completedTilesPercentage,
    progressBarData,
    userData,
    organization,
  } = useGetProgressBarData({ campaignUuid });

  if (!organization.name || !progressBarData.loaded) {
    return (
      <UserProgress id="user_progress">
        <LoadingProgressBar />
      </UserProgress>
    );
  }

  return (
    <UserProgress id="user_progress">
      <TileProgressBarComponent
        demo={demo}
        completedTilesPercentage={completedTilesPercentage}
        userData={userData}
        organization={organization}
        progressBarData={progressBarData}
        canSuggestTile={canSuggestTile}
      />
    </UserProgress>
  );
};

ProgressBarComponent.propTypes = {
  canSuggestTile: PropTypes.bool,
};

export default ProgressBarComponent;

const UserProgress = styled.div`
  margin: 0;
  align-items: center;
  background: transparent;
  padding: 0;
  box-shadow: none;
  display: flex;
  align-content: center;
  color: white;
  justify-content: center;
  width: 100%;

  ${themeGet('mediaQueries.forMediumUp')} {
    gap: 24px;
  }
`;
